import { render, staticRenderFns } from "./StandardReports.vue?vue&type=template&id=525b627e&scoped=true"
import script from "./StandardReports.vue?vue&type=script&lang=js"
export * from "./StandardReports.vue?vue&type=script&lang=js"
import style0 from "./StandardReports.vue?vue&type=style&index=0&id=525b627e&prod&lang=scss"
import style1 from "./StandardReports.vue?vue&type=style&index=1&id=525b627e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b627e",
  null
  
)

export default component.exports